var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.medias),function(media){return _c('v-btn',{key:media.icon,staticClass:"white--text",attrs:{"icon":"","href":media.link,"target":"_blank noopener"}},[_c('v-icon',[_vm._v(" "+_vm._s(media.icon)+" ")])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }